import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyMigration.vue?vue&type=template&id=7d19fd72"
import script from "./MoleculeEditionBillingAcademyMigration.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyMigration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports